var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"image-modal",rawName:"v-image-modal",value:(_vm.enableImageModal),expression:"enableImageModal"}],staticClass:"mark-down-hj",class:{ 'image-modal-enabled': _vm.enableImageModal },domProps:{"innerHTML":_vm._s(_vm.renderedMarkdown)}})
}
var staticRenderFns = []

export { render, staticRenderFns }